import { apiOrigin } from '../api/apiBase';
import { LOCAL_DEFAULTS } from '../constants/defaultAssets';

/**
 * Resolve media URLs — Supabase/CDN absolute URLs or legacy /assets paths.
 */
export function mediaUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//i.test(pathOrUrl) || pathOrUrl.startsWith('data:')) {
    return pathOrUrl;
  }
  if (pathOrUrl.startsWith('/assets/')) {
    return pathOrUrl;
  }

  const base = apiOrigin();
  return `${base}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}

/** DB value first; otherwise bundled local default from public/assets */
export function resolveSiteMedia(settings, field) {
  const value = settings?.[field];
  if (value) return mediaUrl(value);
  return LOCAL_DEFAULTS[field] || '';
}

export default mediaUrl;
